import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdRemoveCircle } from "react-icons/md";
import { LegalAndRegTextInterface, ShowLegalAndRegTextsContext } from "./types";
import { useTranslation } from "react-i18next";

const DataLegalAndRegTexts: React.FC = () => {
  const { legalAndRegTexts } = useSelector((state: State) => state.legalAndRegTexts);

  const {  
    showEditModal, 
    setShowEditModal,
    showDeleteModal, 
    setShowDeleteModal,
    setSelectedLegalAndRegText,
    showDocumentsModal, setShowDocumentsModal,
  } = useContext(ShowLegalAndRegTextsContext)

  const toggleEditLegalAndRegText = (element: LegalAndRegTextInterface) => { 
    setShowEditModal(!showEditModal)
    setSelectedLegalAndRegText(element)
  };

  const toggleDeleteLegalAndRegText = (element: LegalAndRegTextInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedLegalAndRegText(element)
  };

  const toggleShowDocuments = (element: LegalAndRegTextInterface) => { 
    setShowDocumentsModal(!showDocumentsModal)
    setSelectedLegalAndRegText(element)
  };

  const { t } = useTranslation()

  return (
    <div className="flex flex-col border mt-3">
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden">
          <table className="min-w-full text-center text-sm font-light border border-black">
            <thead className="border-b font-medium bg-main text-white border-black">
              <tr>
                <th className="px-4 py-4 border-r border-black">{t("title")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {legalAndRegTexts.map((element: LegalAndRegTextInterface, index) =>(
                <tr className="border-b bg-white border-black" key={index}>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium ">
                    {element.title}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center gap-3">
                      <FaEye
                        className="text-main text-2xl"
                        onClick={() => toggleShowDocuments(element)}
                      />
                      <FaEdit
                        className="text-second text-2xl"
                        onClick={() => toggleEditLegalAndRegText(element)}
                      />
                      <MdRemoveCircle
                        className="text-red text-2xl"
                        onClick={() => toggleDeleteLegalAndRegText(element)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
    // <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-2 mt-4">
    //   {legalAndRegTexts.map((element: LegalAndRegTextInterface, index) => (
    //     <div className={`${element._id === AssId  ? "bg-main" : "" } bg-white px-6 py-4 rounded border shadow hover:bg-main`} 
    //     // style={{ backgroundColor: element.color }}           
    //       key={index}>
    //       <div onClick={() => {
    //         setSelectedLegalAndRegText(element)
    //         navigate(`/element/${element._id}`)
    //       }}>
    //         <div>
    //           <img className="w-40 h-40" src={hostName + "imgs/legalAndRegTexts/" + element.image} alt="ss"/>
    //         </div>
    //         <span className="flex justify-between">
    //           {t("Societé")} : <b>{element.name}</b>
    //         </span>
    //         <span className="flex justify-between">
    //           {t("description")} : <b>{element.description}</b>
    //         </span>
    //       </div>
          // <div className="flex justify-center">
          //   <FaEdit
          //     className="text-blue"
          //     style={{
          //       fontSize: "22px",
          //     }}
          //     onClick={() => toggleEditLegalAndRegText(element)}
          //   />
          //   <MdRemoveCircle
          //     className="text-red"
          //     style={{
          //       fontSize: "22px",
          //     }}
          //     onClick={() => toggleDeleteLegalAndRegText(element)}
          //   />
          // </div>
    //     </div>

    //   ))}
    // </div>
};

export default DataLegalAndRegTexts;
